module.exports = __webpack_public_path__ + "img/manning_vessel.d19488bf.svg";